import React from "react";

const Input = ({ label, value, onChange, placeholder, type = "text", className = "" }) => {
  return (
    <div className="space-y-2">
      {label && <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`w-full px-4 py-2 border rounded-lg shadow-sm focus:ring focus:ring-blue-300 dark:bg-gray-800 dark:text-white ${className}`}
      />
    </div>
  );
};

export { Input };